import * as React from 'react'

import { Box, Tag, Text } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'
import {
  BreakConfigurationFragment,
  UpdateAttendanceShiftMutationVariables,
} from 'generated/resources/graphql'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import Tooltip from 'modules/core/components/Tooltip'
import i18n from 'modules/core/lib/i18n'

import { AttendanceBreakConfigurations } from 'modules/attendance/hooks/useGetAttendanceBreakConfigurationsRange'

interface ShiftCategoryTagProps {
  workable: boolean
  showBreaksList: boolean
  form: FormikProps<UpdateAttendanceShiftMutationVariables>
  allBreaks: BreakConfigurationFragment[]
  dayBreaks: AttendanceBreakConfigurations[]
  timeSettingsBreakConfigurationId?: number
  selectedBreak?: AttendanceBreakConfigurations
  checkSubmit: () => Promise<void>
  automaticClockIn: boolean
}

const ShiftCategoryTag = ({
  form,
  workable,
  allBreaks,
  dayBreaks,
  checkSubmit,
  selectedBreak,
  showBreaksList,
  timeSettingsBreakConfigurationId,
  automaticClockIn,
}: ShiftCategoryTagProps) => {
  const { grey, malibu, lime } = Tag.Types
  const isPaid = selectedBreak?.paid
  const getLabel = () => {
    const isAutomaticBreak = automaticClockIn && !workable

    const breakType = isPaid
      ? i18n.t('time_tracking.settings.custom_breaks.paid_break')
      : i18n.t('time_tracking.settings.custom_breaks.unpaid_break')
    const method = isAutomaticBreak
      ? i18n.t('time_tracking.table.body.category.break.automatic')
      : i18n.t('time_tracking.table.body.category.break.manual')

    return (
      <Box>
        <Text size="200" color="white">
          {breakType}
        </Text>
        <Text size="200" color="white">
          {method}
        </Text>
      </Box>
    )
  }

  const label = getLabel()

  if (!showBreaksList) {
    return !workable ? (
      <Tooltip.Alt attachment="top center" label={label}>
        <Box paddingY="s12" width="fit-content">
          <Tag leftItem="icon" icon="coffee" type={isPaid ? lime : malibu}>
            {timeSettingsBreakConfigurationId
              ? allBreaks.find((b) => b.id === timeSettingsBreakConfigurationId)?.name
              : i18n.t('time_tracking.break')}
          </Tag>
        </Box>
      </Tooltip.Alt>
    ) : (
      <Box paddingY="s12" width="fit-content">
        <Tag leftItem="icon" icon="briefcase" type={grey}>
          {i18n.t('time_tracking.table.body.category.work')}
        </Tag>
      </Box>
    )
  }

  return (
    <PopoverMenu type="list">
      <Tooltip.Alt attachment="top center" label={label}>
        <PopoverMenu.Trigger aria-label="Change status">
          <Tag
            rightItem="dropdown"
            showActionIcon
            leftItem="icon"
            icon="coffee"
            type={isPaid ? lime : malibu}
          >
            {selectedBreak?.name ?? i18n.t('dashboard.clock_in.cta.break')}
          </Tag>
        </PopoverMenu.Trigger>
      </Tooltip.Alt>
      <PopoverMenu.Content side="bottom" align="start" width="s360">
        {dayBreaks.map((b: AttendanceBreakConfigurations) => {
          return (
            <PopoverMenu.TouchableOption
              key={b.timeSettingsBreakConfigurationId}
              title={b.name}
              onClick={() => {
                form.setFieldValue(
                  'timeSettingsBreakConfigurationId',
                  b.timeSettingsBreakConfigurationId
                )
                checkSubmit()
              }}
            />
          )
        })}
      </PopoverMenu.Content>
    </PopoverMenu>
  )
}

export default ShiftCategoryTag
